module.exports = __webpack_public_path__ + "img/coding.9eed4331.png";